import React from 'react';
import { DateInput } from '../../Form/DateInput';

var Input = function Input(props) {
  return /*#__PURE__*/React.createElement(DateInput, {
    className: props.className,
    name: props.name,
    disabled: props.loading || props.disabled,
    error: props.errors[props.name],
    errorText: props.errors[props.name],
    label: props.label,
    onChange: props.handleSelectChange,
    value: props.values[props.name],
    onError: props.setFieldError,
    options: props.options,
    placeholder: props.placeholder,
    useNative: props.useNative
  });
};

export { Input };